import { ValidationRules } from './constants'
import { SENSITIVE_LABEL } from '../../../constants'
import { capitalizeFirstLetter } from '../../../utils/stringUtil'
import { SelectProps } from '@lightbeamai/design-system'

export const getSensitivityLabelOptions = (): SelectProps['options'] => {
  return Object.values(SENSITIVE_LABEL).map((label) => ({
    key: label,
    value: label,
    label: capitalizeFirstLetter(label)
  }))
}

export function validateString(
  str: string,
  minLength: number,
  maxLength: number
): { valid: boolean; rule?: string } {
  // Check length
  if (str.length < minLength || str.length > maxLength) {
    return { valid: false, rule: ValidationRules.min_length }
  }
  return { valid: true, rule: ValidationRules.min_length }

  // todo: uncomment this when we have a proper regex for special characters
  // Check if it starts or ends with a special character
  // const specialCharPattern = /[!@#$%^&*()/=+?\-:;"'<>,.[\]{}|]/
  // const hasSpecialChars = specialCharPattern.test(str)

  // return {
  //   valid: !hasSpecialChars,
  //   rule: ValidationRules.special_characters
  // }
}
